import { RelayNetworkLayerRequest } from 'react-relay-network-modern';
export default function operationNameMiddleware() {
    return function (next) { return function (req) {
        if (typeof req.fetchOpts.body === 'string') {
            var body = JSON.parse(req.fetchOpts.body);
            if (req instanceof RelayNetworkLayerRequest) {
                body.operationName = req.operation.name;
            }
            req.fetchOpts.body = JSON.stringify(body);
        }
        return next(req);
    }; };
}
//# sourceMappingURL=operationName.js.map